// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'



export default {
    name: 'ServiceAdditionalBranches',
        components: {
        IconArrowBack,
        IconBase
    },
    data: () => ({
        additional_branches: false    
    }),
    mounted(){
        this.ValidateSessionData();
        this.$parent.CheckWindowPathName();
        this.$parent.CurrentProcess = "ServiceInsuranceProcess";

    },
    methods: {
        Next(additional_branches) {
            this.$parent.ServiceInsuranceProcess.additional_branches = additional_branches;
            

            if(additional_branches){
                this.$parent.ServiceInsuranceProcess.additional_branches_count = 1;
                this.$parent.ServiceNextStep(9,"ServiceAdditionalBranchesAddress");
            }else{
                this.$parent.ServiceInsuranceProcess.additional_branches_count = 0;
                this.$parent.ServiceInsuranceProcess.ab_address = null;
                this.$parent.ServiceInsuranceProcess.ab_street_number= null;
                this.$parent.ServiceInsuranceProcess.ab_postcode= null;
                this.$parent.ServiceInsuranceProcess.ab_suburb= null;
                this.$parent.ServiceInsuranceProcess.ab_state= null;
                this.$parent.ServiceNextStep(9,"ServiceStartDateOfPolicy");
            }
            
        },
        ValidateSessionData() {
            if(this.$parent.ServiceInsuranceProcess.additional_branches != null) {
                if(this.$parent.ServiceInsuranceProcess.additional_branches) {
                    document.getElementById("Yes").classList.add("selected");
                } else {
                    document.getElementById("No").classList.add("selected");
                }
                this.$validator.validateAll(); /* this was added to add success state on fields and buttons */
            }
        }
    }
}